<template>
  <TransactionListTemplate
    :screenConfig="setScreenConfig"
    :setLoading="setLoading"
    :persistenceKey="'sundry-transactions-list'"
    :rowClick="rowClickCallBack"
    :gcSundryTransactionPopupConfig="gcSundryTransactionPopupConfig"
    ref="sundry-transactions-list"
    class="sundry-transactions-list"
  />
</template>
<script>
import RouteMixin from "@/_mixins/route.mixin";
import FormMixin from "@/_mixins/form.mixin";
import TransactionListTemplate from "../../../templates/transaction-list.vue";
import {
  BankTabs,
  GetIndexByTabName,
} from "../../../_models/tabdata/finance/bank-tabs.js";
import { getBankTransactionColumns } from "../../../_models/tabdata/finance/bank-transaction-columns.js";
import { FeatureStorage } from "../../../_services/storage/index.js";
import { buildSundryTransactionCopySource } from "../../../_helpers/views/bank-transactions.js";

export default {
  mixins: [RouteMixin, FormMixin],
  components: {
    TransactionListTemplate,
  },
  props: {},
  async created() {
    await this.initialized();
  },
  data() {
    return {
      setLoading: false,
      FXCurrency: "FX",
      gcSundryTransactionPopupVisible: false,
      rowCopySource: null,
    };
  },
  methods: {
    async initialized() {
      this.setLoading = true;
      this.setLoading = false;
    },
    rowClickCallBack() {},
    visibleGcSundryTransactionPopup() {
      this.gcSundryTransactionPopupVisible = true;
    },
    gcSundryTransactionPopupCallBack() {
      this.gcSundryTransactionPopupVisible = false;
      this.rowCopySource = null;
    },
    onSaveCallBack() {
      this.$refs["sundry-transactions-list"].$refs[
        "transactionListGrid"
      ].gridRepaint();
    },
    async onRowCopyClick(row) {
      this.setLoading = true;
      try {
        this.rowCopySource = await buildSundryTransactionCopySource(row);
        this.gcSundryTransactionPopupVisible = true;
      } catch (err) {
        this.$store.dispatch("ui/setServerError", {
          error: err,
          title: "Failed",
        });
      } finally {
        this.setLoading = false;
      }
    },
  },
  computed: {
    gcSundryTransactionPopupConfig() {
      return {
        gcPopupVisible: this.gcSundryTransactionPopupVisible,
        gcPopupCallBack: this.gcSundryTransactionPopupCallBack,
        init: this.initialized,
        onSaveCallBack: this.onSaveCallBack,
        parentScreen: "sundry-transactions-list",
        dataModel: this.rowCopySource
          ? {
              BankAccountCode: this.rowCopySource.bankAccountCode,
              AccountNo: this.rowCopySource.accountNo,
              BSBNO: this.rowCopySource.bsbNo,
              FXCurrency: this.rowCopySource.header.CurrencyCode,
              ExchangeRate: this.rowCopySource.header.ExchangeRate,
            }
          : {
              FXCurrency: undefined,
            },
        titleLines: this.rowCopySource
          ? [
              this.rowCopySource.bankAccountName,
              `${this.rowCopySource.bsbNo} ${this.rowCopySource.accountNo}`,
            ]
          : undefined,
        copySource: this.rowCopySource ? this.rowCopySource : undefined,
        formOptions: {
          gcLabelLocation: "left",
        },
      };
    },
    setScreenConfig() {
      var config = {
        title: "Bank Accounts",
        ScreenName: "Bank Accounts - Sundry Transactions",
        selectedIndex: GetIndexByTabName("Sundry Transactions"),
        tabs: BankTabs,
        gridData: {
          gridOptions: {
            dataSource: {
              endpoint: "CashBook",
              filter: [
                [
                  ["TransactionType", "=", "Sundry Payment"],
                  "or",
                  ["TransactionType", "=", "Sundry Receipt"],
                ],
              ],
              serverPaging: true,
              allowGrouping: false,
            },
            noDataMessage: {
              addNew: {
                class: "add-new",
                title: "No Sundry Transactions",
                message: "Get Started, Add a Sundry Transaction",
              },
            },
          },
          toolbar: {
            export: false,
            openFilter: true,
            search: false,
            columnChooser: true,
            expand: false,
            customButtons: [
              {
                icon: "plus",
                label: "Add New",
                visible: FeatureStorage.checkPermission(
                  "BankTransactions",
                  "create",
                ),
                buttonLocation: "left",
                clickAction: () => {
                  this.visibleGcSundryTransactionPopup();
                },
              },
            ],
          },
          columns: getBankTransactionColumns({
            FXCurrency: this.FXCurrency,
            isBankAccountCurrencyTheSameAsCompanyCurrency:
              this.isBankAccountCurrencyTheSameAsCompanyCurrency,
            isSundryTransaction: true,
            onCopyClick: this.onRowCopyClick,
          }),
        },
      };
      return config;
    },
  },
};
</script>
<style lang="scss">
.sundry-transactions-list {
  .dx-datagrid-content td {
    vertical-align: top !important;
  }
}
</style>
